export function divmod(value, lambda) {
  if (lambda === 0) throw new Error('Cannot divide by zero.')

  return [Math.floor(Math.abs(value) / lambda), Math.abs(value) % lambda]
}
